module.exports = __webpack_public_path__ + "static/media/car-bump.f07a9dce.svg";